import { CustomError } from "ts-custom-error";
export class MastoHttpError extends CustomError {
    statusCode;
    description;
    details;
    additionalProperties;
    constructor(props, errorOptions) {
        super(props.message, errorOptions);
        this.statusCode = props.statusCode;
        this.message = props.message;
        this.description = props.description;
        this.additionalProperties = props.additionalProperties;
        this.details = props.details;
    }
}
